import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    /* 
    // This doesn't seem to be needed, leaving in case there are scroll issues
    const scrollableElement = document.querySelector(".Main");
    if (scrollableElement) {
      scrollableElement.scrollTo(0, 0);
    } 
    */
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
